import { render, staticRenderFns } from "./LMain.vue?vue&type=template&id=4647f682"
import script from "./LMain.vue?vue&type=script&lang=js"
export * from "./LMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports